import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";

/** The root is the course area, and its home is the board staff work from.
 *  Nobody lands on the dashboard; Clubside's own home is under super-admin. */
@Injectable({
  providedIn: 'root'
})
export class HomeGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    return this.router.createUrlTree(['/orders/live']);
  }
}
